module.exports = __webpack_public_path__ + "img/02.e2af49ea.png";